export default "__VITE_ASSET__D7Q6pq$A__"